import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-dashboard-runners',
  templateUrl: './runners.component.html',
  styleUrls: ['./runners.component.css']
})
export class RunnersComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  gitlabInstanceName: string;

  @Input()
  runners: any[] = [];


  constructor() {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  ngOnDestroy() {

  }
}
